import { h } from "preact";
import { CartData } from "@sections/cart";

interface MiniCartHeaderButtonProps {
  openDrawer: () => void;
  cartData: CartData | null;
  isWhiteMode?: boolean;
}

// Define a proper interface for the icons
interface IconsObject {
  [key: string]: string;
}

function MiniCartHeaderButton({
  openDrawer,
  cartData,
  isWhiteMode = false,
}: MiniCartHeaderButtonProps) {
  const nonPfandItems = cartData?.items?.filter(
    (item: { title: string }) => item.title !== "Pfand",
  );
  const totalItemCount: number | undefined = nonPfandItems?.reduce(
    (total: number, item: { quantity: number }) => total + item.quantity,
    0,
  );

  const iconKey = isWhiteMode ? "basket_white" : "basket";
  const icons = window.themeVars.icons as IconsObject;
  const iconHtml = icons[iconKey];

  return (
    <button
      onClick={openDrawer}
      className="minicart__toggle"
      aria-label={window.themeVars.strings.accessibility.cartOpen}
    >
      <span
        className="minicart__toggle-icon"
        dangerouslySetInnerHTML={{ __html: iconHtml }}
      ></span>

      {Boolean(totalItemCount) && (
        <span
          className="
          minicart__toggle-count
          text-xs-body
        "
        >
          {totalItemCount}
        </span>
      )}
    </button>
  );
}

export default MiniCartHeaderButton;
